import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes/plugins/rias/ls.rias';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes';
import 'lazysizes/plugins/respimg/ls.respimg';

import menu from './components/menu';
import theme from './components/theme-switcher';
import maps from './components/ga-maps';
import interiorImage from './components/interior-image';
import gallery from './components/gallery';
import panels from './components/panel';
import cursor from './components/cursor';
import linkBlock from './components/link-block';
import transition from './components/transitions';
import fitvid from './components/fitvid';
import filters from './components/hapana-filters';

document.addEventListener('DOMContentLoaded', () => {
	theme.init();
	menu.init();
	maps.init();
	interiorImage.init();
	gallery.init();
	panels.init();
	cursor.init();
	linkBlock.init();
	transition.init();
	fitvid();
	filters.init();
});
